






































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlTextarea from '@/components/common/control/CtrlTextarea.vue';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlChubunrui from '@/components/common/search/CtrlChubunrui.vue';
import CtrlDaibunrui from '@/components/common/search/CtrlDaibunrui.vue';
import CtrlDatePickerMonth from '@/components/common/control/CtrlDatePickerMonth.vue';
import CtrlHimmoku from '@/components/common/search/CtrlHimmoku.vue';
import CtrlJigyosho from '@/components/common/search/CtrlJigyosho.vue';
import CtrlShiiresaki from '@/components/common/search/CtrlShiiresaki.vue';
import CtrlSoko from '@/components/common/search/CtrlSoko.vue';
import CtrlJiko from '@/components/common/search/CtrlJiko.vue';
import CtrlShogTekiyo from '@/components/common/search/CtrlShogTekiyo.vue';
import CtrlShukaArea from '@/components/common/search/CtrlShukaArea.vue';
import CtrlHaisoArea from '@/components/common/search/CtrlHaisoArea.vue';
import CtrlTokuisaki from '@/components/common/search/CtrlTokuisaki.vue';
import CtrlMenuAddress from '@/components/common/search/CtrlMenuAddress.vue';
import CtrlNohinsaki from '@/components/common/search/CtrlNohinsaki.vue';
import CtrlShukasakiSoko from '@/components/common/search/CtrlShukasakiSoko.vue';
import CtrlJigyoshoGinko from '@/components/common/search/CtrlJigyoshoGinko.vue';
import CtrlKanriHimmoku from '@/components/common/search/CtrlKanriHimmoku.vue';
import ListKojoHimmoku from '@/components/common/search/ListKojoHimmoku.vue';
import ListMitsumoriHimmoku from '@/components/common/search/ListMitsumoriHimmoku.vue';
import ListZaiko from '@/components/common/search/ListZaiko.vue';
import ListShukaAreaHimmoku from '@/components/common/search/ListShukaAreaHimmoku.vue';
import CtrlSelect from '@/components/common/control/CtrlSelect.vue';
import CtrlRadioMukoFlg from '@/components/common/control/CtrlRadioMukoFlg.vue';
import CtrlOrderInquiry from '@/components/common/control/CtrlOrderInquiry.vue';
import { calcAmount } from '@/utils/utils';
import { calcHasuTanka } from '@/utils/utils';
import { calcWeight } from '@/utils/utils';
import { checkDigitLength } from '@/utils/utils';

// PDF出力用
import { Rdl as ARJS, PageReport } from '@grapecity/activereports/core';
import { PdfExport } from '@grapecity/activereports';

import { API_SEARCH_JIGYOSHO, API_SEARCH_ZAIKO } from '@/constants/api';
import { DekidakaKb } from '@/constants/constants';

import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Test',
  components: {
    CtrlJigyosho,
    CtrlDaibunrui,
    CtrlDatePicker,
    CtrlNumTxt,
    CtrlNormalTxt,
    CtrlShiiresaki,
    CtrlChubunrui,
    CtrlSoko,
    CtrlJiko,
    CtrlShogTekiyo,
    CtrlShukaArea,
    CtrlMessageDialog,
    CtrlHaisoArea,
    CtrlHimmoku,
    CtrlDatePickerMonth,
    CtrlTokuisaki,
    CtrlMenuAddress,
    CtrlNohinsaki,
    CtrlShukasakiSoko,
    CtrlJigyoshoGinko,
    CtrlKanriHimmoku,
    CtrlSelect,
    ListKojoHimmoku,
    ListMitsumoriHimmoku,
    ListZaiko,
    ListShukaAreaHimmoku,
    CtrlTextarea,
    CtrlRadioMukoFlg,
    CtrlOrderInquiry,
  },
  data: () => ({
    API_SEARCH_JIGYOSHO,
    API_SEARCH_ZAIKO,
    DekidakaKb,
    str_env: '',
    division: '',
    num_cnt: 0,
    fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    fromMonth: '2022-08',
    messageDialogError: false,
    messageDialogQuestion: false,
    messageDialogInfo: false,
    messageDialogWarning: false,
    messageDialogWarningParams: ['{Warning}', '{TEST}'],
    himmokuData: {
      himmokuCd: 4,
      initialDataSearch: true,
      mitsumoriDisplayFlg: false,
      /*
      chubunruiCd: 1,
      daibunruiCd: 2,
      haisoTehaiKb: 3,
      himmokuShuruiPtn: 4,
      gyoshuCd: 5,
      uriageKahiKb: 6,
      shiireKahiKb: 7,
      zaikoKanriKb: 8,
      shiiresakiCd: 9,
      shukaAreaCd: 10,
      shukasakiSokoCd: 11,
      jigyoshoCd: 12,
      tokuisakiCd: 13,
      nohinsakiCd: 14,
      haisoKb: 7,
      mitsumoriUmuFlg: 17,
      mukoUmuFlg: 0,
      */
    },
    selectData: {
      meishoCd: DekidakaKb.DEKI,
    },
    selectData2: {
      meishoCd: DekidakaKb.TONYU,
    },
    orderValue: {
      firstChar: '',
      secondChar: '',
      orderNum: '',
    },
    showListKojoHimmoku: false,
    showListMitsumoriHimmoku: false,
    showListShukaAreaHimmoku: false,
    shiiresakiCd: 1,
    daibunruiCd: 3,
    chubunruiCd: 1,
    jigyoshoCd: 2,
    sokoCd: 2,
    jikoCd: 3,
    shogTekiyoCd: 1,
    shukaAreaCd: 5,
    haisoAreaCd: 6,
    tokuisakiCd: 3,
    nohinsakiCd: 1,
    shukasakiSokoCd: 1,
    sentakuGinkoCd: 1,
    showListZaiko: false,
    pageId: 1,
    tokuiSaki1Data: null,
    tokuiSaki2Data: null,
    tokuiSaki3Data: { tokuisakiCd: 12 },
    ctrlSelect1Data: null,
    ctrlNumTxt1Value: -6744787687687.6789,
    ctrlNumTxt1ValueDisp: '',
    ctrNormal1TxtData: '',
    tanka: 600,
    suryo: 20,
    hasu: 3,
    irisu: 7,
    bubiki: 15,
    caseWeight: 40,
    targetYmd: null,
    tanka2: null,
  }),
  mounted() {
    setTimeout(() => {
      this.shiiresakiCd = 8552001;
      this.daibunruiCd = 8;
      this.chubunruiCd = 7;
      this.jigyoshoCd = 90;
      this.himmokuData.himmokuCd = 4;
      this.sokoCd = 237;
      this.jikoCd = 6;
      this.shogTekiyoCd = 9;
      this.shukaAreaCd = 8;
      this.haisoAreaCd = 3;
      this.tokuisakiCd = 536001;
    }, 3000);
  },
  methods: {
    handleOk(item: any) {
      console.log('handleOk', item);
    },
    handleCancel() {
      console.log('handleCancel');
    },

    callbackCancel(ctrlName: string) {
      console.log(`callbackCancel --- ${ctrlName}`);
    },
    handleChangeRadioGroup(val: any) {
      console.log(`handleChangeRadioGroup --- ${val}`);
    },
    callbackOk() {
      // console.log(`callbackOk --- ${ctrlName}`, params);
    },
    // PDF出力用
    buildReportDefinition(): ARJS.Report {
      const report: ARJS.Report = {};
      report.Width = '8.5in';
      report.Page = {
        TopMargin: '0.5in',
        BottomMargin: '0.5in',
        LeftMargin: '0.5in',
        RightMargin: '0.5in',
        PageWidth: '8.5in',
        PageHeight: '11in',
      };
      const textbox: ARJS.Textbox = { Type: 'textbox', Name: 'txtGreetings' };
      textbox.Value = 'Hello, ActiveReportsJS';
      textbox.Style = {
        FontSize: '18pt',
      };
      textbox.Width = '7in';
      textbox.Height = '0.5in';
      report.Body = { ReportItems: [textbox] };
      return report;
    },
    async exportReport(
      reportDefinition: ARJS.Report
    ): Promise<PdfExport.PdfExportResult> {
      const pageReport = new PageReport();
      await pageReport.load(reportDefinition);
      const doc = await pageReport.run();
      return PdfExport.exportDocument(doc, {
        info: {
          title: 'Generated by ActiveReportsJS',
        },
      });
    },
    setPDF(e: any) {
      e.preventDefault();
      const reportDefinition = this.buildReportDefinition();
      this.exportReport(reportDefinition)
        .then((result) => {
          console.log(result);
          result.download('ActiveReportsJSReport');
        })
        .catch(console.error);
    },
    alertCtrlTokuisakiData() {
      alert(
        `${JSON.stringify(this.tokuiSaki1Data)} ${JSON.stringify(
          this.tokuiSaki2Data
        )} ${JSON.stringify(this.tokuiSaki3Data)}`
      );
    },
    alertCtrlSelectData() {
      alert('★' + JSON.stringify(this.selectData2));
    },
    alertCtrNumTxtData() {
      alert(
        JSON.stringify({
          ctrlNumTxt1ValueDisp: this.ctrlNumTxt1ValueDisp,
          ctrlNumTxt1Value: this.ctrlNumTxt1Value,
        })
      );
    },
    alertCtrNormalTxtData() {
      alert(this.ctrNormal1TxtData);
    },
    emitData(firstChar: string, secondChar: string, orderNum: string) {
      this.orderValue.firstChar = firstChar;
      this.orderValue.secondChar = secondChar;
      this.orderValue.orderNum = orderNum;
    },
    alertCtrlOrderInquiry() {
      alert(
        JSON.stringify({
          FirstChar: this.orderValue.firstChar,
          secondChar: this.orderValue.secondChar,
          orderNum: this.orderValue.orderNum,
        })
      );
    },
    testCalcAmount() {
      const tanka = this.tanka;
      const suryo = this.suryo;
      const hasu = this.hasu;
      const irisu = this.irisu;
      const bubiki = this.bubiki;
      const amount = calcAmount(tanka, suryo, hasu, irisu, bubiki);
      console.log('((単価 - 歩引) * 数量) + (端数単価 * 端数)');
      console.log(
        '((' +
          tanka +
          ' - ' +
          bubiki +
          ') * ' +
          suryo +
          ') + ( 計算した端数単価 * ' +
          hasu +
          ')'
      );
      console.log('金額:' + amount);
    },
    testCalcHasuTanka() {
      const tanka = this.tanka;
      const irisu = this.irisu;
      const bubiki = this.bubiki;
      const hasuTanka = calcHasuTanka(tanka, irisu, bubiki);
      console.log('端数単価 = (単価 - 歩引) / 入数');
      console.log('(' + this.tanka + ' - ' + this.bubiki + ') / ' + this.irisu);
      console.log('端数単価:' + hasuTanka);
    },
    testCalcWeight() {
      const caseWeight = this.caseWeight;
      const suryo = this.suryo;
      const hasu = this.hasu;
      const irisu = this.irisu;
      const weight = calcWeight(caseWeight, suryo, hasu, irisu);

      console.log('( ケース重量 * 数量 ) + 端数重量');
      console.log('( ' + caseWeight + ' * ' + suryo + ' ) + 計算した端数重量');
      console.log('重量:' + weight);
    },
    syncChubunruiCd(item: any) {
      this.chubunruiCd = item.chubunruiCd;
    },
    getShukaAreaHimmoku(items: any) {
      console.log(items);
    },
    getKojoHimmoku(items: any) {
      console.log(items);
    },
    getMitsumoruHimmoku(items: any) {
      console.log(items);
    },
    getZaiko(items: any) {
      console.log('★ ' + JSON.stringify(items));
    },
  },

  created() {
    this.targetYmd = this.userInfo.onlineData.genzaiYmd;

    console.log('123.123, 3, 2 => false');
    console.log(checkDigitLength(123.123, 3, 2));
    console.log('123.123, 3, 3 => true');
    console.log(checkDigitLength(123.123, 3, 3));
    console.log('123.123, 3, 0 => false');
    console.log(checkDigitLength(123.123, 3, 0));
    console.log('123.123, 3 => true');
    console.log(checkDigitLength(123.123, 3));
  },
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
  },
});
